import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import Typography from "Components/CommonComponents/Typography";
import { UserInfoContext } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import { ElmentDetail } from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentPerformanceTabs/StudentDetailsTab";
import { useContext, useState } from "react";
import {
  Col,
  Popover,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
// import styled from "styled-components";
import "./index.css";
import { capitalizeWords } from "utilFunctions/helperFunctions/utilFunctions";
// const ActiveProfileTextDiv = styled<any>("span")`
//   border-radius: 5px;
//   padding: 4px;
//   background: ${(props: any) => (props.isActive ? "#50b47f" : "#E7685A")};
//   color: var(--White, #fff);
//   text-align: center;
//   font-size: 10.328px;
//   font-style: normal;
//   font-weight: 400;
//   width: fit-content;
// `;
const MyBatchesFacultyDetailTab = ({
  facultyDetail,
  screen,
  branches,
  regions,
  streams,
  route,
}: any) => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { masters } = useMasterContext();
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const [popoverContent, setPopoverContent] = useState<any>([]);
  console.log(popoverContent);
  const [hoveredColumn, setHoveredColumn] = useState<string | null>(null);
  const togglePopover = (column: string, content: string) => {
    setHoveredColumn(column);
    setPopoverContent(content);
    setPopoverOpen(!popoverOpen);
  };

  const closePopover = () => {
    setHoveredColumn(null);
    setPopoverOpen(false);
  };
  const returnRegion = (ids: any) => {
    const regionIDs = ids && ids != null ? ids : [];
    return regions
      ?.filter((ele: any) => regionIDs.includes(ele.id))
      ?.map((el: any) => el.label);
  };
  const returnBranchName = (branch: any) => {
    const branchArr = branch.map(Number) || [];
    console.log("branchArr", branchArr, branches);
    return branches
      ?.filter((ele: any) => branchArr.includes(ele.id))
      ?.map((el: any) => el.label);
  };
  const returnStreamName = (stream: any) => {
    const streamArr = stream.map(Number) || [];
    console.log("branchArr", streamArr, streams);
    return streams
      ?.filter((ele: any) => streamArr.includes(ele.id))
      ?.map((el: any) => el.label);
  };
  console.log(userInfo, "userInfo", masters, facultyDetail);
  return (
    <div
      className={
        ["xxl", "xl", "lg"].includes(screen)
          ? "MyBatchesFacultyDetailTabDiv mr-0"
          : "MyBatchesFacultyDetailTabDivMB pt-0"
      }
    >
      {route == "myprofile" ? (
        <Row>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="12"
            xs="12"
            className="text-left pl-4 pt-3"
          >
            <Typography variant="h5" color="black">
              Aakash Guru Profile Data
            </Typography>
          </Col>
        </Row>
      ) : null}
      {facultyDetail != null ? (
        <Row className="MyBatchesFacultyDetailTabRow mt-0">
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol"
          >
            <ElmentDetail
              label={"Faculty Name"}
              value={
                facultyDetail["name"] != null &&
                capitalizeWords(facultyDetail["name"])
              }
            />
          </Col>

          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            <ElmentDetail
              label={"Faculty Id"}
              value={facultyDetail["employeeId"]}
            />
          </Col>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            <div
              className="d-flex flex-column facultyDetailsCol"
              id="region"
              onClick={() =>
                userInfo.employeeId == facultyDetail["employeeId"]
                  ? togglePopover("region", returnRegion(userInfo["region"]))
                  : togglePopover(
                      "region",
                      returnRegion(facultyDetail["region"])
                    )
              }
              onMouseLeave={closePopover}
            >
              <span className="studentLabel">Region</span>
              {userInfo.employeeId == facultyDetail["employeeId"] ? (
                <div className="d-flex gap-2">
                  {returnRegion(userInfo["region"])?.[0] &&
                  returnRegion(userInfo["region"]).length > 1 ? (
                    <>
                      <span className="studentValue">
                        {returnRegion(userInfo["region"])?.[0]}{" "}
                      </span>
                      <span className="filterSpan d-flex align-items-center">
                        +{returnRegion(userInfo["region"])?.length - 1}
                      </span>
                    </>
                  ) : (
                    <span className="studentValue">
                      {returnRegion(userInfo["region"])?.[0]}
                    </span>
                  )}
                </div>
              ) : (
                <div className="d-flex gap-2">
                  {returnRegion(facultyDetail["region"])?.[0] &&
                  returnRegion(facultyDetail["region"]).length > 1 ? (
                    <>
                      <span className="studentValue">
                        {returnRegion(facultyDetail["region"])?.[0]}{" "}
                      </span>
                      <span className="filterSpan d-flex align-items-center">
                        +{returnRegion(facultyDetail["region"])?.length - 1}
                      </span>
                    </>
                  ) : (
                    <span className="studentValue">
                      {returnRegion(facultyDetail["region"])?.[0]}
                    </span>
                  )}
                </div>
              )}
            </div>

            <Popover
              placement="bottom"
              isOpen={hoveredColumn == "region" ? popoverOpen : false}
              target={"region"}
              toggle={closePopover}
            >
              <PopoverBody className="FacultyTablePopover">
                {popoverContent.map((ele: any, index: number) => (
                  <div
                    key={index}
                    className="branchListing d-flex justify-content-between mb-2"
                  >
                    {ele}
                  </div>
                ))}
              </PopoverBody>
            </Popover>
          </Col>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            <div
              className="d-flex flex-column facultyDetailsCol"
              id="branch"
              onClick={() =>
                togglePopover(
                  "branch",
                  returnBranchName(facultyDetail["branch"])
                )
              }
            >
              <span className="studentLabel">Branches</span>
              <div className="d-flex gap-2">
                {returnBranchName(facultyDetail["branch"])?.[0] &&
                returnBranchName(facultyDetail["branch"]).length > 1 ? (
                  <>
                    <span className="studentValue">
                      {returnBranchName(facultyDetail["branch"])?.[0]}{" "}
                    </span>
                    <span className="filterSpan d-flex align-items-center">
                      +{returnBranchName(facultyDetail["branch"])?.length - 1}
                    </span>
                  </>
                ) : (
                  <span className="studentValue">
                    {returnBranchName(facultyDetail["branch"])?.[0]}
                  </span>
                )}
              </div>
            </div>

            <UncontrolledPopover
              placement="bottom"
              target={"branch"}
              trigger="legacy"
            >
              <PopoverBody className="FacultyTablePopover branchPopover">
                {popoverContent.map((ele: any, index: number) => (
                  <div
                    key={index}
                    className="branchListing d-flex justify-content-between mb-2"
                  >
                    {ele}
                  </div>
                ))}
              </PopoverBody>
            </UncontrolledPopover>
          </Col>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            <div
              onClick={() =>
                togglePopover(
                  "stream",
                  returnStreamName(facultyDetail.streamIds)
                )
              }
              onMouseLeave={closePopover}
              id={"stream"}
              className="facultyDetailsCol"
            >
              <Popover
                placement="bottom"
                isOpen={hoveredColumn == "stream" ? popoverOpen : false}
                target={"stream"}
                toggle={closePopover}
              >
                <PopoverBody className="FacultyTablePopover">
                  {Object.values(popoverContent)?.map(
                    (ele: any, index: number) => (
                      <div
                        key={index}
                        className="branchListing d-flex justify-content-between mb-2"
                      >
                        {ele}
                      </div>
                    )
                  )}
                </PopoverBody>
              </Popover>
              <span className="studentLabel">Stream</span>
              <div className="d-flex gap-2">
                {returnStreamName(facultyDetail.streamIds)?.[0] &&
                returnStreamName(facultyDetail.streamIds).length > 1 ? (
                  <>
                    <span className="studentValue">
                      {returnStreamName(facultyDetail.streamIds)?.[0]}{" "}
                    </span>
                    <span className="filterSpan d-flex align-items-center">
                      +{returnStreamName(facultyDetail.streamIds)?.length - 1}
                    </span>
                  </>
                ) : (
                  <span className="studentValue">
                    {returnStreamName(facultyDetail.streamIds)?.[0]}
                  </span>
                )}
              </div>
            </div>
          </Col>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            <div
              onClick={() => togglePopover("subject", facultyDetail.subjects)}
              onMouseLeave={closePopover}
              id={"subject"}
              className="facultyDetailsCol"
            >
              <Popover
                placement="bottom"
                isOpen={hoveredColumn == "subject" ? popoverOpen : false}
                target={"subject"}
                toggle={closePopover}
              >
                <PopoverBody className="FacultyTablePopover">
                  {popoverContent?.map((ele: any, index: number) => (
                    <div
                      key={index}
                      className="branchListing d-flex justify-content-between mb-2"
                    >
                      {ele}
                    </div>
                  ))}
                </PopoverBody>
              </Popover>
              <span className="studentLabel">Subjects</span>
              <div className="d-flex gap-2">
                {facultyDetail.subjects && facultyDetail.subjects.length > 1 ? (
                  <>
                    {facultyDetail?.subjects?.[0]}{" "}
                    <span className="filterSpan d-flex align-items-center">
                      +{facultyDetail?.subjects?.length - 1}
                    </span>
                  </>
                ) : (
                  <>{facultyDetail?.subjects?.[0]}</>
                )}
              </div>
            </div>
          </Col>
          {/* <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol d-flex flex-column mt-2"
          >
            <span className="studentLabel">Status</span>
            <ActiveProfileTextDiv isActive={facultyDetail["status"] != 1}>
              {facultyDetail["status"] != 1 ? "Active" : "Inactive"}
            </ActiveProfileTextDiv>
          </Col> */}
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            <ElmentDetail
              label={"Role"}
              value={
                facultyDetail["fexRole"] !== null &&
                facultyDetail["fexRole"] === "Branch EDP"
                  ? "EDP Team"
                  : facultyDetail["fexRole"]
              }
            />
          </Col>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            <ElmentDetail
              label={"Faculty Email ID"}
              value={facultyDetail["email"]}
            />
          </Col>
        </Row>
      ) : (
        <div className="mt-4 mb-8">
          <NoResultFoundSearch
            primaryMessage="Data not found"
            secondaryMessage={
              "Seems like there was an error loading data                  "
            }
          >
            <NoDataFoundIcon />
          </NoResultFoundSearch>
        </div>
      )}
    </div>
  );
};
export default MyBatchesFacultyDetailTab;
